/**
 * Math JavaScript helper functions.
 *
 * @module MathHelper
 * @author EN GARDE
 * @version 1
 */

var EN = EN || {};

EN.MathHelper = (function () {
	'use strict';

	/**
	 * Maps a value from one range to another range.
	 * @example mapValue(10, 0, 100, 0, 1) = 0.1
	 * @param {number} value – the original value
	 * @param {number} oldMin – the original minimum value
	 * @param {number} oldMax – the original maximum value
	 * @param {number} newMin – the new minimum value
	 * @param {number} newMax – the new maximum value
	 * @param {boolean} [cutOverflow] - Whether or not to limit the resulting value to newMax/newMin.
	 * e.g. mapValue(200, 0, 100, 0, 1, true) = 1
	 * e.g. mapValue(200, 0, 100, 0, 1, false) = 2
	 * @return {number}
	 */
	var mapValue = function (value, oldMin, oldMax, newMin, newMax, cutOverflow) {
		var newValue = (value - oldMin) / (oldMax - oldMin) * (newMax - newMin) + newMin;

		if (cutOverflow) {
			newValue = Math.min(newValue, newMax);
			newValue = Math.max(newValue, newMin);
		}

		return newValue;
	};

	// exports
	return {
		mapValue: mapValue
	};
}());
